import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=a09f005a&scoped=true&"
import script from "./Versions.vue?vue&type=script&lang=js&"
export * from "./Versions.vue?vue&type=script&lang=js&"
import style0 from "./Versions.vue?vue&type=style&index=0&id=a09f005a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09f005a",
  null
  
)

export default component.exports